import React from 'react';
import WifiIcon from '@mui/icons-material/Wifi';
import { Box, Tooltip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

function TestConnectionButton({ onClick }) {
  const theme = useTheme();
  const { t } = useTranslation();
  return (
    <Tooltip title={t("TestConnection")}>
      <Box
        onClick={onClick}
        sx={{
          backgroundColor: theme.palette.custom.buttonColor,
          borderRadius: "4px",
          border: `1px solid ${theme.palette.custom.borderColor}`,
          // display: "flex",
          // justifyContent: "center",
          width: "46px",
          height: "36px",
          padding: "5px 10px",
        }}
      >
        <WifiIcon
          sx={{
            color: theme.palette.custom.buttonTextColor,
            fontSize: 24,
          }}
        />
      </Box>
    </Tooltip>
  );
}
TestConnectionButton.propTypes = {
  onClick: PropTypes.func,
};

export default TestConnectionButton;
